<template>
  <flex-layout wrap>
    <base-input :model-value="props.lastName" class="col-6" placeholder="姓（全角）"
                required-tag @update:model-value="emit('update:lastName', $event)"
                :rules="[rules.requiredWithLabelName({name: '姓'}),
                 rules.onlyFullWightWithLabelName({name: '姓'}),
                  rules.onlyJapaneseCharactersWithLabelName({name: '姓'})]"
    />
      <base-input :model-value="props.firstName" class="col-6" placeholder="名（全角）"
                  :rules="[rules.requiredWithLabelName({name: '名'}),
    rules.onlyFullWightWithLabelName({name: '名'}),
    rules.onlyJapaneseCharactersWithLabelName({name: '名'})]"
                  required-tag @update:model-value="emit('update:firstName', $event)"/>
  </flex-layout>
</template>
<script setup lang="ts">
import {useValidator} from "@/composable/ui/useValidator";
import BaseInput from "@/components/Forms/BaseInput.vue";
import {defineEmits} from "vue";
import FlexLayout from "@/components/Layouts/FlexLayout.vue";

const props = defineProps({
  firstName: {
    type: String,
    required: true
  },
  lastName: {
    type: String,
    required: true
  }
});

const emit = defineEmits(['update:firstName', 'update:lastName']);
const {rules} = useValidator();

</script>
<style scoped>


</style>
